import { Injectable } from '@angular/core';

/**
 * Wraps window.localStorage with JSON serialization and error handling.
 * Used to persist user preferences (e.g. "Assigned to Me" toggles, filter state) across sessions.
 */
@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  public get<T>(key: string): T | null {
    try {
      const value = localStorage.getItem(key);
      return value ? (JSON.parse(value) as T) : null;
    } catch (e) {
      return null;
    }
  }

  public set(key: string, value: any): void {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  public remove(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (e) {}
  }
}
